import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHero } from "@/components/PageHero";
import pageCover from "@/assets/kupish/p-reklamacije.webp";

export const Route = createFileRoute("/reklamacije")({
  head: () => {
    const url = "https://kupish.si/reklamacije";
    const title = "Reklamacije — kupish.si";
    const description = "Postopek reševanja reklamacij, stvarne napake in pravice kupcev pri nakupu izdelkov v spletnem nakupovalnem središču kupish.si.";
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: Page,
});

function Page() {
  return (
    <article className="pb-24">
      <PageHero src={pageCover} alt="Reklamacije in vračila na kupish.si — minimalističen 3D prikaz vračila paketa">
        <Link to="/pogoji" className="text-xs uppercase tracking-[0.18em] text-accent hover:underline">
          ← Splošni pogoji poslovanja
        </Link>
        <h1 className="font-serif text-4xl md:text-6xl mt-6 leading-[1.05] tracking-tight">
          Reševanje <span className=" text-accent">reklamacij</span>
        </h1>
        <time className="mt-5 block text-sm text-muted-foreground">Zadnja sprememba: september 2026</time>
      </PageHero>

      <div className="mx-auto max-w-3xl px-6 mt-14 md:mt-20">
        <div className="article-prose">
          <h2>Reševanje sporov in uporaba prava</h2>
          <p>
            Z oddajo ponudbe prodajalca za posamezen izdelek in sprejemom te ponudbe s strani kupca
            se med prodajalcem in kupcem vzpostavi obligacijsko razmerje.
          </p>
          <p>
            Vsi morebitni spori iz tega razmerja (vključno s spori glede resničnosti podatkov o
            uporabniku, vsebine ponudbe, predmeta ali cene) se rešujejo izključno med prodajalcem in
            kupcem. Upravljavec spletnega mesta ne nosi nikakršne odgovornosti v primeru spora med
            uporabniki, saj ni neposredno vpleten v to razmerje.
          </p>
          <p>
            Z uporabo spletnega mesta kupish.si se kupci in prodajalci zavezujejo, da bodo
            morebitne spore reševali sporazumno in v dobri veri.
          </p>
          <p>
            Vsak uporabnik spletnega mesta sprejema ta pravila ter se izrecno odpoveduje pravici do
            uveljavljanja morebitne odškodnine od upravljavca spletnega mesta kupish.si,
            ki bi nastala iz zgoraj navedenega razmerja med prodajalcem in kupcem.
          </p>
          <p>
            Za ta pravila in vsa pravna razmerja, ki iz njih izhajajo, se uporablja pravo Republike
            Slovenije. V primeru, da sporazumna rešitev spora ni mogoča, je za reševanje sporov
            pristojno stvarno pristojno sodišče v Ljubljani.
          </p>
        </div>
      </div>
    </article>
  );
}
